import { apiFetch } from "../utils/apiFetch";
import { API_BASE_OPERATOR as API_BASE } from "../config/vars";

export const fetchDevices = async () => {
    const response = await apiFetch(`${API_BASE}/devices/operator`);
    if (!response.ok) throw new Error("Не вдалося завантажити пристрої");
    return response.json();
};

export const fetchLocations = async () => {
    const response = await apiFetch(`${API_BASE}/locations/operator`);
    if (!response.ok) throw new Error("Не вдалося завантажити локації");
    const data = await response.json();
    return data.filter(loc => loc.status);
};

export const fetchWorkModes = async () => {
    const response = await apiFetch(`${API_BASE}/devices/operator/work-modes`);
    if (!response.ok) throw new Error("Не вдалося завантажити режими роботи");
    return response.json();
};

export const fetchStatuses = async () => {
    const response = await apiFetch(`${API_BASE}/config/operator?table_name=devices&column_name=status`);
    if (!response.ok) throw new Error("Не вдалося завантажити статуси");
    return response.json();
};

export const fetchSockets = async () => {
    const response = await apiFetch(`${API_BASE}/devices/operator/available-sockets`);
    if (!response.ok) throw new Error("Не вдалося завантажити розетки");
    return response.json();
};

export const updateDevice = async (id, deviceData) => {
    const response = await apiFetch(`${API_BASE}/devices/operator/${id}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(deviceData),
    });
    if (!response.ok) throw new Error("Не вдалося оновити пристрій");
};

export const addDevice = async (deviceData) => {
    const response = await apiFetch(`${API_BASE}/devices/operator`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(deviceData),
    });
    if (!response.ok) throw new Error("Не вдалося додати пристрій");
};
